import { forwardRef, type Ref, type SVGProps } from "react";
const IconClapFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M15.579 7.29c.38-.042.764.05 1.083.263a1.575 1.575 0 0 1 .203 2.396l-4.173 4.172a.394.394 0 0 0 .557.557l5.224-5.225a1.63 1.63 0 0 1 2.083-.232 1.576 1.576 0 0 1 .203 2.397l-5.286 5.284a.394.394 0 0 0 .557.557l4.112-4.113a1.63 1.63 0 0 1 2.083-.23 1.572 1.572 0 0 1 .201 2.396l-4.17 4.172a.395.395 0 0 0 .01.545.394.394 0 0 0 .545.011l3-3a1.634 1.634 0 0 1 2.083-.231 1.576 1.576 0 0 1 .202 2.396l-8.341 8.342a6.294 6.294 0 0 1-8.9 0l-1.208-1.212-.843-.843a7.87 7.87 0 0 1-2.304-5.56v-7.59a1.574 1.574 0 0 1 2.683-1.113c.295.295.461.695.461 1.112v3.23a.39.39 0 0 0 .242.364.4.4 0 0 0 .43-.085l8.264-8.266a1.63 1.63 0 0 1 .999-.494"
    />
    <path
      fill="currentColor"
      d="M24.528 15.19c.38-.043.764.05 1.083.262a1.573 1.573 0 0 1 .203 2.397l-.536.535-.217.168s.009-.046.086-.258a1.575 1.575 0 0 0-.567-1.824 1.63 1.63 0 0 0-1.083-.263c-.38.042-.288.033-.494.06l.526-.584a1.63 1.63 0 0 1 1-.493"
    />
    <path
      fill="currentColor"
      d="M5.875 9.692a1.217 1.217 0 0 1 1.217 1.217l.06 2.31.008.11a.75.75 0 0 0 .455.583l-1.368 1.393v-3.008c.008-.52-.234-1.582-1.482-1.81.002-.01.028-.214.25-.437.228-.228.538-.357.86-.358"
    />
    <path
      fill="currentColor"
      d="M23.013 11.269c.381-.043.764.05 1.083.262a1.574 1.574 0 0 1 .203 2.396l-.536.536-.217.168s.008-.046.086-.258a1.576 1.576 0 0 0-.567-1.825 1.63 1.63 0 0 0-1.084-.262c-.38.042-.287.033-.493.06l.526-.584a1.63 1.63 0 0 1 1-.493"
    />
    <path
      fill="currentColor"
      d="M21.231 7.347c.38-.042.764.051 1.083.263a1.575 1.575 0 0 1 .568 1.824 1.6 1.6 0 0 1-.366.572l-.536.536-.217.167c.001-.005.012-.053.086-.257a1.58 1.58 0 0 0-.566-1.825 1.64 1.64 0 0 0-1.084-.263c-.38.042-.287.034-.493.062l.526-.585a1.63 1.63 0 0 1 1-.494"
    />
    <path
      fill="currentColor"
      d="M28.816 7.764a.684.684 0 0 1 0 1.368h-1.933a.686.686 0 0 1-.485-1.168.7.7 0 0 1 .485-.2z"
    />
    <path
      fill="currentColor"
      d="M17.4 5.743c.38-.042.763.05 1.082.263a1.575 1.575 0 0 1 .202 2.396l-.535.536-.218.167s.009-.046.086-.257a1.574 1.574 0 0 0-.566-1.825 1.63 1.63 0 0 0-1.083-.262c-.38.042-.288.033-.494.061l.526-.585a1.63 1.63 0 0 1 1-.494"
    />
    <path
      fill="currentColor"
      d="M28.25 3.577a.685.685 0 0 1 .483 1.168l-1.45 1.45a.684.684 0 0 1-.968-.966l1.451-1.452a.68.68 0 0 1 .484-.2"
    />
    <path
      fill="currentColor"
      d="M24.28 2.423a.684.684 0 0 1 .55.67v1.935a.685.685 0 0 1-1.367 0V3.094a.684.684 0 0 1 .817-.671"
    />
  </svg>
);
const ForwardRef = forwardRef(IconClapFilledSVG);
ForwardRef.displayName = "IconClapFilled";
export { ForwardRef as IconClapFilled };
